'use strict';

var React = require('react');
var breakpoints = require('../../../constants/breakpoints.cjs');

const getScreenSize = (width)=>{
    if (width < breakpoints.MIN_BREAKPOINTS.tablet834) return breakpoints.SCREEN_SIZES.mobile375;
    if (width < breakpoints.MIN_BREAKPOINTS.desktop1024) return breakpoints.SCREEN_SIZES.tablet834;
    if (width < breakpoints.MIN_BREAKPOINTS.desktop1280) return breakpoints.SCREEN_SIZES.desktop1024;
    return breakpoints.SCREEN_SIZES.desktop1280;
};
const getScreenSizeFromDeviceType = (deviceType)=>{
    if (deviceType === "mobile") return breakpoints.SCREEN_SIZES.mobile375;
    if (deviceType === "tablet") return breakpoints.SCREEN_SIZES.tablet834;
    return breakpoints.SCREEN_SIZES.desktop1024;
};
const determineScreenWidth = (deviceType)=>{
    if (typeof window === "undefined") {
        return getScreenSizeFromDeviceType(deviceType);
    }
    return getScreenSize(window.innerWidth);
};
/**
 * Detects the current screen size based on the window width
 */ const useScreenSize = (deviceType)=>{
    const [screenSize, setScreenSize] = React.useState(determineScreenWidth(deviceType));
    React.useEffect(()=>{
        if (typeof window === "undefined") return;
        const handleResize = ()=>{
            setScreenSize(getScreenSize(window.innerWidth));
        };
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return screenSize;
};

exports.useScreenSize = useScreenSize;
//# sourceMappingURL=useScreenSize.cjs.map
